/* ss-reel.js — parte un video per volta, solo quando è in vista */
(function () {
  var vids = [].slice.call(document.querySelectorAll('video[data-ss-reel]'));
  if (!vids.length || !('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting && e.intersectionRatio > 0.6) {
        if (v.readyState === 0) v.load();
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) { v.pause(); }
    });
  }, { threshold: [0, 0.6] });
  vids.forEach(function (v) { io.observe(v); });
})();
